import { render, staticRenderFns } from "./EaNotActiveSection.vue?vue&type=template&id=de2bdfb8&lang=pug&"
import script from "./EaNotActiveSection.vue?vue&type=script&lang=js&"
export * from "./EaNotActiveSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports